import { useCurrentUserStore } from '@/stores/currentUser.ts';
import type { MenuItem, MenuGroup } from '@/components/shared/sidebar/sidebar_menu';

export const useMainSidebar = () => {
  const currentUserStore = useCurrentUserStore();

  const menuGroups = (): MenuGroup[] => [
    {
      show: true,
      items: [
        {
          title: 'Dashboard',
          url: '/',
          icon: 'home',
          show: true,
        },
        {
          title: 'Jobs',
          url: '/jobs?sort=created&order=desc&status=Active',
          icon: 'bookmark',
          show: currentUserStore.isAdmin(),
        },
        {
          title: 'Candidates',
          url: '/contacts?sort=created&order=desc',
          icon: 'users',
          show: true,
        },
      ],
    },
    {
      show: true,
      items: [
        {
          title: 'Team',
          url: '/teammates?status=Active&sort=created&order=desc',
          icon: 'life-buoy',
          show: true,
        },
        {
          title: 'Pipeline Reviews',
          url: '/pipeline_reviews',
          icon: 'clipboard',
          show: true,
        },
        {
          title: 'Settings',
          url: '/settings',
          icon: 'settings',
          show: true,
        },
      ],
    },
  ];

  const lowerMenuItems: MenuItem[] = [
    {
      title: 'Product Updates',
      url: '/product_updates',
      icon: 'radio',
      show: true,
    },
  ];

  return { menuGroups: menuGroups(), lowerMenuItems };
};
